import styled from 'styled-components';
import { Media } from 'enums';
import { Button } from 'view/atoms';

export const NoDiscountsPage = styled.div`
  width: 100%;
  padding: 30px 20px 100px;
  background-color: #f5f5f4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ButtonAddDiscount = styled(Button)`
  display: flex;
  height: 48px;
  margin-top: 40px;
  column-gap: 10px;

  @media ${Media.notebook} {
    height: 64px;
    width: 343px;
    margin-top: 54px;
  }
`;
